'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024 from "./com.raquo.airstream.core.-Observer$.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dVar$0024 from "./com.raquo.airstream.state.-Var$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V($thiz) {
  $thiz.jC = $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024.$m_Lcom_raquo_airstream_core_Observer$();
  $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$();
  $thiz.dU = $j_com$002eraquo$002eairstream$002estate$002e$002dVar$0024.$m_Lcom_raquo_airstream_state_Var$();
}
export { $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V as $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V };
